import { render, staticRenderFns } from "./BeneficioFuneralModal.vue?vue&type=template&id=7cf43757&scoped=true&"
import script from "./BeneficioFuneralModal.vue?vue&type=script&lang=js&"
export * from "./BeneficioFuneralModal.vue?vue&type=script&lang=js&"
import style0 from "./BeneficioFuneralModal.vue?vue&type=style&index=0&id=7cf43757&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf43757",
  null
  
)

export default component.exports